import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from 'src/@/components/ui/select';
import { Input } from 'src/@/components/ui/input';
import { MKT } from '../marketing.design';

function getPeriodOptions(t) {
    return [
        { value: 'last-7-days', label: t('common.period.last7Days') },
        { value: 'last-14-days', label: t('common.period.last14Days') },
        { value: 'last-30-days', label: t('common.period.last30Days') },
        { value: 'last-90-days', label: t('common.period.last90Days') },
        { value: 'custom', label: t('common.period.custom') },
    ];
}

export default function PeriodFilter({
    period,
    onPeriodChange,
    startDate,
    endDate,
    onStartDateChange,
    onEndDateChange,
    barClassName,
    groupClassName,
    labelClassName,
    controlClassName,
}) {
    const { t } = useTranslation('marketing');
    const periodOptions = useMemo(() => getPeriodOptions(t), [t]);

    return (
        <div className={barClassName ?? MKT.filters.bar}>
            <div className={groupClassName ?? MKT.filters.group}>
                <label className={labelClassName ?? MKT.filters.label}>{t('common.period.label')}</label>
                <Select value={period} onValueChange={onPeriodChange}>
                    <SelectTrigger className={`w-[170px] ${controlClassName ?? MKT.filters.control}`}>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="z-[9999]" position="popper" sideOffset={4}>
                        {periodOptions.map((opt) => (
                            <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            {period === 'custom' && (
                <>
                    <div className={groupClassName ?? MKT.filters.group}>
                        <label className={labelClassName ?? MKT.filters.label}>{t('common.period.from')}</label>
                        <Input
                            type="date"
                            className={`w-[150px] ${controlClassName ?? MKT.filters.control}`}
                            value={startDate}
                            onChange={(e) => onStartDateChange(e.target.value)}
                        />
                    </div>
                    <div className={groupClassName ?? MKT.filters.group}>
                        <label className={labelClassName ?? MKT.filters.label}>{t('common.period.to')}</label>
                        <Input
                            type="date"
                            className={`w-[150px] ${controlClassName ?? MKT.filters.control}`}
                            value={endDate}
                            onChange={(e) => onEndDateChange(e.target.value)}
                        />
                    </div>
                </>
            )}
        </div>
    );
}
